import React from 'react'
import privacyBanner from '../assets/images/banner/privacyBanner.png';
import privacyMobileBanner from '../assets/images/banner/privacyBannerMobile.png';


const PrivacyPolicy = () => {
  return (
    <>
      <div
        className="d-none d-md-block"
        style={{ height: "100vh", width: "100vw" }}
      >
        <img
          src={privacyBanner}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div>

      <div className="d-md-none" style={{ height: "100vh", width: "100vw" }}>
        <img
          src={privacyMobileBanner}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div>

      <section className="py-5 py-md-6" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-10">
              <div className="bg-white p-3 p-md-4 p-lg-5 shadow-sm rounded-3">
                <h2 className="mb-3 mb-md-4 text-center text-md-start">
                  Privacy Commitment
                </h2>

                <p className="mb-3 mb-md-4">
                  At Chain & Links, we value your privacy and are dedicated to
                  safeguarding your personal information. We strictly adhere to
                  the principle that no personal data or information will be
                  published, sold, or rented to any third party without your
                  explicit consent.
                </p>

                <p className="mb-3 mb-md-4">
                  This Privacy Policy outlines the practices we follow for our
                  services offered under our website and its subdomains. By
                  accessing this site, you agree to be bound by the terms and
                  conditions of this policy. If you disagree with any part of
                  it, we advise you not to use our site.
                </p>
                <p className="mb-3 mb-md-4">
                  Please note that this policy does not apply to external
                  websites we may link to. We are not responsible for any
                  personal information you submit to third parties via those
                  sites. We encourage you to review their privacy policies
                  before providing your details.
                </p>
                <p className="mb-3 mb-md-4">
                  This policy describes the types of information we collect as
                  part of our service operations, and how that information may
                  be used. It is provided to help you make an informed decision
                  about sharing your personal information with us. By using our
                  site, you agree to the collection and use of your information
                  as described in this policy. This Privacy Policy is part of
                  and subject to the terms of our User Agreement.
                </p>

                <h2 className="mb-3 mb-md-4 text-center text-md-start">
                  Privacy Assurance
                </h2>
                <p className="mb-3 mb-md-4">
                  Chain & Links guarantees that we will not sell or rent your
                  personal information to third parties for marketing purposes
                  without your explicit consent.
                </p>
                <p className="mb-3 mb-md-4">
                  From time to time, we may share aggregated statistical
                  information about our website’s usage—such as the number of
                  visitors or the types of services used—while ensuring your
                  personal data remains fully confidential.
                </p>
                <p className="mb-3 mb-md-4">
                  Access to your information is strictly limited to authorized
                  employees who need it to perform their duties. Any employee
                  found violating our privacy policies is subject to
                  disciplinary actions, including termination and legal
                  consequences.
                </p>

                <h2 className="mb-3 mb-md-4 text-center text-md-start">
                  Information Collection
                </h2>
                <p className="mb-3 mb-md-4">
                  We collect personal information for two main purposes:
                </p>
                <ul className="mb-0 ps-3 ps-md-4">
                  <li className="mb-1">
                    We collect personal information for two main purposes:
                  </li>
                  <li className="mb-1">
                    To ensure a smooth, personalized, and high-quality
                    experience on our website.
                  </li>
                  <p className="mb-3 mb-md-4">
                    This policy applies to all personal data provided through
                    any media, unless explicitly stated otherwise.
                  </p>
                  <p className="mb-3 mb-md-4">
                    We employ physical, electronic, and managerial measures to
                    ensure the safety and confidentiality of the personal
                    information we collect.
                  </p>
                  <p className="mb-3 mb-md-4">
                    We may use cookies to analyze website traffic, measure
                    promotional effectiveness, and enhance your overall
                    experience. Cookies are small files stored on your device,
                    which allow us to offer certain features. You can choose to
                    decline our cookies if your browser allows.
                  </p>
                  <p className="mb-3 mb-md-4">
                    Please note that third-party cookies may be present on
                    certain pages of our site, for which we do not have control.
                    These cookies may be placed by external service providers
                    for analytics or advertising.
                  </p>
                  <p className="mb-3 mb-md-4">
                    By providing your personal information voluntarily, you
                    acknowledge and consent to its collection. We may use your
                    IP address for website administration, troubleshooting, and
                    gathering broad demographic information.
                  </p>
                </ul>

                <h2 className="mb-3 mb-md-4 text-center text-md-start">
                  Cookie Policy
                </h2>
                <p className="mb-3 mb-md-4">
                  At Chain & Links, we are committed to transparency regarding
                  the use of cookies on our website. Cookies are essential in
                  enhancing your browsing experience and making it more
                  efficient and tailored to your preferences.
                </p>

                <h2 className="mb-3 mb-md-4 text-center text-md-start">
                  Why Cookies Matter
                </h2>
                <p className="mb-3 mb-md-4">
                  Cookies allow us to:
                </p>
                <ul className="mb-0 ps-3 ps-md-4">
                  <li className="mb-1">
                    Remember your preferences
                  </li>
                  <li className="mb-1">
                    Improve website navigation
                  </li>
                  <li className="mb-1">
                    Understand usage patterns
                  </li>
                  <li className="mb-1">
                    Offer a smoother and more relevant browsing experience
                  </li>
                  </ul>
                  <h2 className="mb-3 mb-md-4 text-center text-md-start">
                 Types of Cookies
                </h2>
                <h5 className="mb-3 mb-md-4 text-center text-md-start">
                 Session Cookies
                </h5>
                <p className="mb-3 mb-md-4">
                  Temporary cookies that are deleted once you close your browser.
                </p>
                <h5 className="mb-3 mb-md-4 text-center text-md-start">
                 Persistent Cookies
                </h5>
                <p className="mb-3 mb-md-4">
                  Cookies that remain in your browser until they expire or are manually deleted. These help us understand usage patterns and improve our services.
                </p>
                 <h2 className="mb-3 mb-md-4 text-center text-md-start">
                 Cookie Categories
                </h2>
                <h5 className="mb-3 mb-md-4 text-center text-md-start">
                 Essential Cookies
                </h5>
                <p className="mb-3 mb-md-4">
                  Required for basic website functionality and security.
                </p>
                <h5 className="mb-3 mb-md-4 text-center text-md-start">
                 Functional Cookies
                </h5>
                <p className="mb-3 mb-md-4">
                  Remember your preferences to give you a more personalized experience.
                </p>
                <h5 className="mb-3 mb-md-4 text-center text-md-start">
                Analytics Cookies
                </h5>
                <p className="mb-3 mb-md-4">
                  Used to track website performance and how visitors interact with our pages.
                </p>
                <h5 className="mb-3 mb-md-4 text-center text-md-start">
                 Advertising Cookies
                </h5>
                <p className="mb-3 mb-md-4">
                  Allow us and our trusted partners to display relevant ads based on your interests.
                </p>
                <p className="mb-3 mb-md-4">
                  We limit the use of third-party cookies to reliable and trusted partners, ensuring they align with our privacy and security standards.
                </p>
                 <p className="mb-3 mb-md-4">
                  For information on how to delete cookies or manage your privacy settings, refer to your browser’s privacy and security options.
                </p>
              </div>
              
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy